export const ApiConfig = {
  API_URL: window.env.CONFIG_API_GATEWAY_URL,
  API_MAP_KEY: window.env.CONFIG_API_MAP_KEY,
  PROJECT_ID: {
    USER_SERVICE: window.env.CONFIG_NODEJS_G24H_LAUNDRY_USER_SERVICE_ID,
    MEDIA_SERVICE: window.env.CONFIG_NODEJS_G24H_LAUNDRY_MEDIA_SERVICE_ID ?? 18,
    PRODUCT_SERVICE: window.env.CONFIG_NODEJS_G24H_LAUNDRY_PRODUCT_SERVICE_ID,
    ORDER_SERVICE: window.env.CONFIG_NODEJS_G24H_LAUNDRY_ORDER_SERVICE_ID,
    CUSTOMER_SERVICE: window.env.CONFIG_NODEJS_G24H_LAUNDRY_CUSTOMER_SERVICE_ID,
    LOG_SERVICE: window.env.CONFIG_NODEJS_G24H_LAUNDRY_AUDIT_LOG_SERVICE_ID,
    ACCOUNTING_SERVICE: window.env.CONFIG_NODEJS_G24H_LAUNDRY_ACCOUNTING_SERVICE_ID,
    HRM_SERVICE: window.env.CONFIG_NODEJS_G24H_LAUNDRY_HRM_SERVICE_ID,
    PAYMENT_SERVICE: window.env.CONFIG_NODEJS_G24H_LAUNDRY_PAYMENT_SERVICE_ID,
  },

};

export const API_PUBLIC_ROUTER = {
  VERSION: "v1",
  get API_SETTING() {
    return `${this.VERSION}/settings/public`;
  },
};
// Setting global (key/value) — USER_SERVICE
export const API_SETTING_ROUTER = {
  VERSION: "v1",
  get API_ALL() {
    return `${this.VERSION}/settings/all`;
  },
};
export const API_OAUTH_ROUTER = {
  VERSION: "v1",
  get API_LOGIN() {
    return `${this.VERSION}/auth/login`;
  },
  get VERIFY_OTP_LOGIN() {
    return `${this.VERSION}/auth/verify-otp-login`;
  },
  get VERIFY_OTP_FORGOT_PASSWORD() {
    return `${this.VERSION}/auth/verify-otp-forgot-password`;
  },
  get RESET_PASSWORD() {
    return `${this.VERSION}/auth/reset-password`;
  },
  get CHANGE_PASSWORD() {
    return `${this.VERSION}/auth/change-password`;
  },
  get FORGOT_FORGOT_PASSWORD() {
    return `${this.VERSION}/auth/forgot-password`;
  },
  get API_LOGOUT() {
    return `${this.VERSION}/auth/logout`;
  },
};

export const API_UPLOAD_ROUTER = {
  VERSION: "v1",
  get API_UPLOAD() {
    return `${this.VERSION}/upload/files`;
  },
  get API_SHORT() {
    return `${this.VERSION}/upload/short`;
  },
};

export const API_EMPLOYEE_ROUTER = {
  VERSION: "v1",
  get API_GET_EMPLOYEES() {
    return `${this.VERSION}/users`;
  },

  API_GET_EMPLOYEE_DETAIL(id: string) {
    return `${this.VERSION}/users/${id}/detail`;
  },
  API_CHANGE_PASSWORD_EMPLOYEE(id: string) {
    return `${this.VERSION}/users/${id}/change-password`;
  },

  API_UPDATE_EMPLOYEE(id: string) {
    return `${this.VERSION}/users/${id}/update`;
  },
  API_UPDATE_2FA() {
    return `${this.VERSION}/users/2fa`;
  },
};
export const API_SERVICE_ROUTER = {
  VERSION: "v1",
  get API_LIST_SERVICE() {
    return `${this.VERSION}/services/list`;
  },
  get API_CREATE() {
    return `${this.VERSION}/services/create`;
  },
  API_UPDATE_SERVICE(id: number) {
    return `${this.VERSION}/services/${id}/update`;
  },
  API_CHANGE_STATUS_SERVICE(id: number) {
    return `${this.VERSION}/services/${id}/change-status`;
  },
  API_DETAIL_SERVICE(id: number) {
    return `${this.VERSION}/services/${id}`;
  },
};
export const API_SERVICE_TYPE_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/service-types/list`;
  },
  get API_CREATE() {
    return `${this.VERSION}/service-types/create`;
  },
  API_UPDATE_SERVICE(id: number) {
    return `${this.VERSION}/service-types/${id}/update`;
  },
  API_CHANGE_STATUS_SERVICE(id: number) {
    return `${this.VERSION}/service-types/${id}/change-status`;
  },
  API_DETAIL_SERVICE(id: number) {
    return `${this.VERSION}/service-types/${id}`;
  },
  get API_COPY_FROM_BRANCH() {
    return `${this.VERSION}/service-types/copy-from-branch`;
  },
};
export const API_SERVICE_ADDON_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/service-addons/list`;
  },
  get API_CREATE() {
    return `${this.VERSION}/service-addons/create`;
  },
  API_CHANGE_STATUS_SERVICE(id: number) {
    return `${this.VERSION}/service-addons/${id}/change-status`;
  },
  API_CHANGE_PRICE_SERVICE(id: number) {
    return `${this.VERSION}/service-addons/${id}/change-price`;
  },
  API_DETAIL_SERVICE(id: number) {
    return `${this.VERSION}/service-addons/${id}`;
  },
};
export const API_SERVICE_TYPE_MAPS_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/service-type-maps/list`;
  },
  get API_CREATE() {
    return `${this.VERSION}/service-type-maps/create`;
  },
  /** Tạo 1 dòng bảng giá (1 dịch vụ trong 1 nhóm). */
  get API_CREATE_MAPPING() {
    return `${this.VERSION}/service-type-maps/mapping/create`;
  },
  /** Sửa 1 dòng bảng giá (không đổi nhóm / dịch vụ). */
  API_UPDATE_MAPPING(id: number) {
    return `${this.VERSION}/service-type-maps/mapping/${id}/update`;
  },
  get API_COPY_FROM_BRANCH() {
    return `${this.VERSION}/service-type-maps/copy-from-branch`;
  },
  get API_COPY_ALL_FROM_BRANCH() {
    return `${this.VERSION}/service-type-maps/copy-all-from-branch`;
  },
  API_CHANGE_STATUS_SERVICE(id: number) {
    return `${this.VERSION}/service-type-maps/${id}/change-status`;
  },
  API_CHANGE_PRICE_SERVICE(id: number) {
    return `${this.VERSION}/service-type-maps/${id}/update-price`;
  },
  API_UPDATE_SERVICE(service_id: number) {
    return `${this.VERSION}/service-type-maps/${service_id}/update`;
  },
  API_GET_BY_SERVICE(service_id: number) {
    return `${this.VERSION}/service-type-maps/by_service/${service_id}`;
  },
  API_GET_BY_TYPE(service_type_id: number) {
    return `${this.VERSION}/service-type-maps/by_type/${service_type_id}`;
  },
};
export const API_DEPARTMENT_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/departments/`;
  },
  get API_CREATE() {
    return `${this.VERSION}/departments/create`;
  },
  API_CHANGE_STATUS(id: number) {
    return `${this.VERSION}/departments/${id}/change-status`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/departments/${id}/update`;
  },
  API_DETAIL(id: number) {
    return `${this.VERSION}/departments/${id}/detail`;
  },
  API_PRIVILEGE(id: number) {
    return `${this.VERSION}/departments/${id}/privileges`;
  },
  API_UPDATE_PRIVILEGE(id: number) {
    return `${this.VERSION}/departments/${id}/assign`;
  },
};
export const API_USER_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/users/`;
  },
  get API_CREATE() {
    return `${this.VERSION}/users/create`;
  },
  API_CHANGE_STATUS(id: number) {
    return `${this.VERSION}/users/${id}/change-status`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/users/${id}/update`;
  },
  API_DETAIL(id: number) {
    return `${this.VERSION}/users/${id}/detail`;
  },
  API_RESET_PASSWORD(id: number) {
    return `${this.VERSION}/users/${id}/reset-password`;
  },
  API_PRIVILEGE(id: number) {
    return `${this.VERSION}/users/${id}/privileges`;
  },
  API_UPDATE_PRIVILEGE(id: number) {
    return `${this.VERSION}/users/${id}/assign`;
  },
  API_ASSIGN_CUSTOMER(id: number) {
    return `${this.VERSION}/users/${id}/assign-customer`;
  },
  get API_COUNT_TABS() {
    return `${this.VERSION}/users/count-tabs`;
  },
  // NV xưởng (quyền PRODUCTION_STAFF) của 1 chi nhánh — dùng cho phân công giặt/sấy/ủi/gấp.
  get API_PRODUCTION_STAFF() {
    return `${this.VERSION}/users/production-staff`;
  },
  get API_EXCEL_TEMPLATE() {
    return `${this.VERSION}/users/excel/template`;
  },
  get API_EXCEL_IMPORT() {
    return `${this.VERSION}/users/excel/import`;
  },
};

/**
 * Tài khoản đăng nhập app khách hàng — nằm ở USER_SERVICE, KHÔNG phải CUSTOMER_SERVICE.
 *
 * Hồ sơ khách (tên, địa chỉ, chiết khấu, công nợ) do CUSTOMER_SERVICE quản lý; bảng
 * `customer_accounts` bên USER_SERVICE chỉ giữ phần đăng nhập và trỏ sang hồ sơ đó
 * qua `customer_id`.
 */
export const API_CUSTOMER_ACCOUNT_ROUTER = {
  VERSION: "v1",
  get API_LOOKUP_BY_CUSTOMERS() {
    return `${this.VERSION}/customer-account/lookup-by-customers`;
  },
  get API_ISSUE() {
    return `${this.VERSION}/customer-account/issue`;
  },
  API_RESET_PASSWORD(id: number) {
    return `${this.VERSION}/customer-account/${id}/reset-password`;
  },
};

export const API_ORDER_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/order-laundry/`;
  },
  get API_CREATE() {
    return `${this.VERSION}/order-laundry/create`;
  },
  get API_RESYNC_RESPONSIBLE_CUSTOMER_STAFF() {
    return `${this.VERSION}/order-laundry/resync-responsible-customer-staff`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/order-laundry/${id}/update`;
  },
  API_DETAIL(id: number) {
    return `${this.VERSION}/order-laundry/${id}/detail`;
  },
  API_CANCEL(id: number) {
    return `${this.VERSION}/order-laundry/${id}/cancel`;
  },
  API_CHANGE_STATUS(id: number) {
    return `${this.VERSION}/order-laundry/${id}/update-status`;
  },
  API_GENERATE_PAYMENT_QR_CODE(id: number) {
    return `${this.VERSION}/order-laundry/${id}/payment/generate`;
  },
  API_CANCEL_PAYMENT_QR_CODE(id: number) {
    return `${this.VERSION}/order-laundry/${id}/payment/cancel`;
  },
  API_DETAIL_PAYMENT_QR_CODE(id: number) {
    return `${this.VERSION}/order-laundry/${id}/payment/detail`;
  },
  // Extended Workflow (Phase 2)
  API_SPLIT_ORDER(id: number) {
    return `${this.VERSION}/order-laundry/${id}/split`;
  },
  API_SUB_ORDERS(id: number) {
    return `${this.VERSION}/order-laundry/${id}/sub-orders`;
  },
  API_WORKFLOW_HISTORY(id: number) {
    return `${this.VERSION}/order-laundry/${id}/workflow-history`;
  },
  API_LAST_CLASSIFICATION(id: number) {
    return `${this.VERSION}/order-laundry/${id}/last-classification`;
  },
  /** SL loại đồ suy từ SL dịch vụ tính cái/lần — nút "Lấy số lượng từ dịch vụ". */
  API_CLASSIFICATION_FROM_SERVICES(id: number) {
    return `${this.VERSION}/order-laundry/${id}/classification-from-services`;
  },
  API_CLASSIFICATION(id: number) {
    return `${this.VERSION}/order-laundry/${id}/classification`;
  },
  API_RE_WASH(id: number) {
    return `${this.VERSION}/order-laundry/${id}/re-wash`;
  },
  API_ISSUE_PHOTO(id: number) {
    return `${this.VERSION}/order-laundry/${id}/issue-photo`;
  },
  API_ISSUES(id: number) {
    return `${this.VERSION}/order-laundry/${id}/issues`;
  },
  // Sửa SL / đơn giá dòng vật tư (cần quyền ORDER_ITEM_QUANTITY_EDIT / OPERATION_SUPERVISOR)
  API_UPDATE_ITEMS(id: number) {
    return `${this.VERSION}/order-laundry/${id}/items`;
  },
  // Đổi hình thức thanh toán đơn ĐÃ HOÀN TẤT (Tiền mặt ↔ Công nợ) — cùng quyền ORDER_ITEM_QUANTITY_EDIT
  API_CHANGE_PAYMENT_METHOD(id: number) {
    return `${this.VERSION}/order-laundry/${id}/payment-method`;
  },
  // Sửa sản lượng (cân lần 2) đơn ĐÃ HOÀN TẤT — cùng quyền ORDER_ITEM_QUANTITY_EDIT, không đụng tiền
  API_COMPLETED_FINAL_WEIGHT(id: number) {
    return `${this.VERSION}/order-laundry/${id}/completed-final-weight`;
  },
  // "Huỷ SQTM" — GET xem trước / POST huỷ khoản thu + lần nộp tiền mặt (quyền DRIVER_CASH_DEPOSIT_CANCEL)
  API_CASH_DEPOSIT_CANCEL(id: number) {
    return `${this.VERSION}/order-laundry/${id}/cash-deposit-cancel`;
  },
  // Sửa ảnh xác nhận 1 bước (quyền ORDER_PHOTO_EDIT)
  API_STEP_PHOTOS(id: number) {
    return `${this.VERSION}/order-laundry/${id}/step-photos`;
  },
  // Danh sách tài xế trong chi nhánh kèm số đơn đang treo (để chỉ định đơn)
  get API_ASSIGNABLE_DRIVERS() {
    return `${this.VERSION}/order-laundry/assignable-drivers`;
  },
  // Điều chuyển chi nhánh
  API_CREATE_TRANSFER(id: number) {
    return `${this.VERSION}/order-laundry/${id}/transfer`;
  },
  API_ORDER_TRANSFERS(id: number) {
    return `${this.VERSION}/order-laundry/${id}/transfers`;
  },
  API_ORDER_EQUIPMENTS(id: number) {
    return `${this.VERSION}/order-laundry/${id}/equipments`;
  },
  API_TRANSFER_IN_TRANSIT(transferId: number) {
    return `${this.VERSION}/order-laundry/transfer/${transferId}/in-transit`;
  },
  API_TRANSFER_RECEIVE(transferId: number) {
    return `${this.VERSION}/order-laundry/transfer/${transferId}/receive`;
  },
  API_TRANSFER_CANCEL(transferId: number) {
    return `${this.VERSION}/order-laundry/transfer/${transferId}/cancel`;
  },
  get API_INCOMING_TRANSFERS() {
    return `${this.VERSION}/order-laundry/transfers/incoming`;
  },
};

// Xuất Excel danh sách đơn (chạy nền) — ORDER_SERVICE. Tạo job → hỏi tiến độ → tải file.
export const API_ORDER_EXPORT_ROUTER = {
  VERSION: "v1",
  get API_CREATE() {
    return `${this.VERSION}/order-laundry-export`;
  },
  API_STATUS(jobId: string) {
    return `${this.VERSION}/order-laundry-export/${jobId}`;
  },
  API_DOWNLOAD(jobId: string) {
    return `${this.VERSION}/order-laundry-export/${jobId}/download`;
  },
};

// Yêu cầu điều chỉnh (số lượng kiểm đếm nhận/giao, công nợ đồ) — ORDER_SERVICE
export const API_ADJUSTMENT_REQUEST_ROUTER = {
  VERSION: "v1",
  get API_LIST_COUNTING() {
    return `${this.VERSION}/adjustment-requests/counting`;
  },
  API_APPROVE_COUNTING(id: number) {
    return `${this.VERSION}/adjustment-requests/counting/${id}/approve`;
  },
  API_REJECT_COUNTING(id: number) {
    return `${this.VERSION}/adjustment-requests/counting/${id}/reject`;
  },
  API_RELATED_FAULT_TICKETS(id: number) {
    return `${this.VERSION}/adjustment-requests/counting/${id}/related-fault-tickets`;
  },
  // Xem trước sổ nợ đồ của đơn sẽ thay đổi thế nào nếu duyệt (đơn đã kiểm đếm giao).
  API_DEBT_IMPACT(id: number) {
    return `${this.VERSION}/adjustment-requests/counting/${id}/debt-impact`;
  },
  get API_LIST_DEBT() {
    return `${this.VERSION}/adjustment-requests/debt`;
  },
  // Cùng path với API_LIST_DEBT (GET) — tách tên riêng cho rõ ý khi dùng ở chỗ tạo phiếu (POST).
  get API_CREATE_DEBT() {
    return `${this.VERSION}/adjustment-requests/debt`;
  },
  API_APPROVE_DEBT(id: number) {
    return `${this.VERSION}/adjustment-requests/debt/${id}/approve`;
  },
  API_REJECT_DEBT(id: number) {
    return `${this.VERSION}/adjustment-requests/debt/${id}/reject`;
  },
};

// Quản lý phiếu lỗi (ORDER_SERVICE)
export const API_FAULT_TICKET_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/fault-tickets`;
  },
  get API_CREATE() {
    return `${this.VERSION}/fault-tickets`;
  },
  API_DETAIL(id: number) {
    return `${this.VERSION}/fault-tickets/${id}`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/fault-tickets/${id}/update`;
  },
  API_EXPLAIN(id: number) {
    return `${this.VERSION}/fault-tickets/${id}/explain`;
  },
  get API_REPORT() {
    return `${this.VERSION}/fault-tickets/report`;
  },
  /** SLA riêng theo khách hàng — không có override cho mốc nào thì mốc đó dùng cấu hình chung */
  get API_CUSTOMER_SLA_OVERRIDES() {
    return `${this.VERSION}/fault-tickets/customer-sla-overrides`;
  },
  /** Tra hàng loạt khách nào đang có override — cột trạng thái ở bảng danh sách khách */
  get API_CUSTOMER_SLA_OVERRIDES_LOOKUP() {
    return `${this.VERSION}/fault-tickets/customer-sla-overrides/lookup`;
  },
  /** Bắt đầu đồng bộ tay phiếu lỗi sang đối tác — chạy NỀN, trả về ngay (quét 10 ngày gần nhất) */
  get API_SYNC_RUN() {
    return `${this.VERSION}/fault-sync/run`;
  },
  /** Tiến độ phiên đồng bộ tay gần nhất — poll sau khi gọi API_SYNC_RUN */
  get API_SYNC_STATUS() {
    return `${this.VERSION}/fault-sync/status`;
  },
  /** Gửi lại một phiếu — đường duy nhất đẩy phiếu ở trạng thái "cần kiểm tra" */
  get API_SYNC_RETRY() {
    return `${this.VERSION}/fault-sync/retry`;
  },
};
export const API_BANK_TRANSFER_ROUTER = {
  VERSION: "v1",
  /** Biến động số dư (tiền vào) từ webhook ngân hàng + tổng hợp theo trạng thái khớp */
  get API_LIST() {
    return `${this.VERSION}/bank-transfers`;
  },
  /** Gán tay giao dịch cho 1 đơn và ghi nhận thanh toán */
  API_ASSIGN_ORDER(id: number) {
    return `${this.VERSION}/bank-transfers/${id}/assign-order`;
  },
  /** Tạo lại phiếu thu cho giao dịch đã khớp đơn mà bước phiếu thu trước đó lỗi */
  API_RETRY_VOUCHER(id: number) {
    return `${this.VERSION}/bank-transfers/${id}/retry-voucher`;
  },
  /** Đánh dấu giao dịch không thuộc đơn nào */
  API_IGNORE(id: number) {
    return `${this.VERSION}/bank-transfers/${id}/ignore`;
  },
};
export const API_ORDER_REPORT_ROUTER = {
  VERSION: "v1",
  /** Đối soát khối lượng theo khách hàng (Dơ/Sạch theo ngày, nợ đầu–cuối kỳ) */
  get API_CUSTOMER_RECONCILIATION() {
    return `${this.VERSION}/order-report/customer-reconciliation`;
  },
  /** Xuất Excel đối soát của 1 khách — trả file ngay (không chạy nền) */
  get API_CUSTOMER_RECONCILIATION_EXPORT() {
    return `${this.VERSION}/order-report/customer-reconciliation/export`;
  },
  /** Đối soát đơn hàng (tổng hợp): top khách nợ đồ / đồ không chuẩn + bảng theo kỳ */
  get API_ITEM_DEBT_OVERVIEW() {
    return `${this.VERSION}/order-report/item-debt-overview`;
  },
  /** Báo cáo đồ giặt lại */
  get API_REWASH_REPORT() {
    return `${this.VERSION}/order-report/rewash`;
  },
  /** Danh sách đơn giặt lại đứng sau một dòng của báo cáo (bóc tách theo chi nhánh / lý do / khách / NV) */
  get API_REWASH_ORDERS() {
    return `${this.VERSION}/order-report/rewash/orders`;
  },
  /** Báo cáo xuất bán: doanh thu theo dịch vụ + theo chi nhánh chủ đơn */
  get API_SALES_OUTPUT_REPORT() {
    return `${this.VERSION}/order-report/sales-output`;
  },
  /** Xuất Excel báo cáo xuất bán — trả file ngay (không chạy nền) */
  get API_SALES_OUTPUT_REPORT_EXPORT() {
    return `${this.VERSION}/order-report/sales-output/export`;
  },
};
export const API_CUSTOMER_ITEM_DEBT_ROUTER = {
  VERSION: "v1",
  get API_BALANCE() {
    return `${this.VERSION}/customer-item-debt/balance`;
  },
  get API_LOGS() {
    return `${this.VERSION}/customer-item-debt/logs`;
  },
  get API_ADJUST() {
    return `${this.VERSION}/customer-item-debt/adjust`;
  },
};
export const API_CUSTOMER_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/customers/list`;
  },
  get API_COUNT_TABS() {
    return `${this.VERSION}/customers/count-tabs`;
  },
  get API_CREATE() {
    return `${this.VERSION}/customers/create`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/customers/${id}/update`;
  },
  API_DETAIL(id: number) {
    return `${this.VERSION}/customers/${id}/detail`;
  },
  get API_EXCEL_TEMPLATE() {
    return `${this.VERSION}/customers/excel/template`;
  },
  get API_EXCEL_IMPORT() {
    return `${this.VERSION}/customers/excel/import`;
  },
};
export const API_RECEIPTS_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/receipts`;
  },
  get API_CREATE() {
    return `${this.VERSION}/receipts/create`;
  },
  API_DETAIL(id: number) {
    return `${this.VERSION}/receipts/${id}`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/receipts/${id}/update`;
  },
  API_CHANGE_STATUS(id: number) {
    return `${this.VERSION}/receipts/${id}/change-status`;
  },
  get API_COUNT_TAB() {
    return `${this.VERSION}/receipts/count-tab`;
  },
  get API_INCOME_OVERVIEW() {
    return `${this.VERSION}/receipts/income/get-income`;
  },
};
export const API_SERVICE_VARIANTS_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/service-variants/list`;
  },
  get API_CREATE() {
    return `${this.VERSION}/service-variants/create`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/service-variants/${id}/update`;
  },
  API_DETAIL(id: number) {
    return `${this.VERSION}/service-variants/${id}`;
  },
  API_CHANGE_STATUS(id: number) {
    return `${this.VERSION}/service-variants/${id}/change-status`;
  },
};
export const API_DRIVER_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/drivers/`;
  },
  get API_CREATE() {
    return `${this.VERSION}/drivers/create`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/drivers/${id}/update`;
  },
  API_DETAIL(id: number) {
    return `${this.VERSION}/drivers/${id}/detail`;
  },
  API_CHANGE_STATUS(id: number) {
    return `${this.VERSION}/drivers/${id}/change-status`;
  },
};
export const API_TRANSPORT_VEHICLE_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/transport-vehicles`;
  },
  get API_CREATE() {
    return `${this.VERSION}/transport-vehicles/create`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/transport-vehicles/${id}/update`;
  },
  API_DELETE(id: number) {
    return `${this.VERSION}/transport-vehicles/${id}/delete`;
  },
  /** Xem trước chuyển cả đội hình xe `id` sang xe khác (`?to_vehicle_id=`). */
  API_TRANSFER_PREVIEW(id: number) {
    return `${this.VERSION}/transport-vehicles/${id}/transfer-preview`;
  },
  /** Chuyển cả đội hình xe `id` sang xe khác — đơn / chuyến chưa xong đi theo. */
  API_TRANSFER(id: number) {
    return `${this.VERSION}/transport-vehicles/${id}/transfer`;
  },
  /** Người chọn làm tài xế / phụ xe (tài xế toàn hệ thống, kèm xe đang thuộc). */
  get API_CREW_OPTIONS() {
    return `${this.VERSION}/transport-vehicles/crew-options`;
  },
  /** Xe để CHỌN cho đơn (không cần quyền quản lý xe): chỉ xe hoạt động có tài xế, kèm đội hình + tỷ lệ. */
  get API_VEHICLE_OPTIONS() {
    return `${this.VERSION}/vehicle-handovers/options/vehicles`;
  },
};

export const API_BRANCH_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/branch/`;
  },
  get API_MY_BRANCHES() {
    return `${this.VERSION}/branch/my-branches`;
  },
  get API_CREATE() {
    return `${this.VERSION}/branch/create`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/branch/${id}/update`;
  },
  API_DETAIL(id: number) {
    return `${this.VERSION}/branch/${id}/detail`;
  },
  API_CHANGE_STATUS(id: number) {
    return `${this.VERSION}/branch/${id}/change-status`;
  },
};

export const API_PRIVILEGE_ROUTER = {
  VERSION: "v1",
  get API_PRIVILEGE_LIST() {
    return `${this.VERSION}/privileges/`;
  },
  get API_GROUP_LIST() {
    return `${this.VERSION}/privilege-groups/`;
  },
  get API_GROUP_CREATE() {
    return `${this.VERSION}/privilege-groups/create`;
  },
  API_GROUP_UPDATE(id: number) {
    return `${this.VERSION}/privilege-groups/${id}/update`;
  },
  API_GROUP_DETAIL(id: number) {
    return `${this.VERSION}/privilege-groups/${id}/detail`;
  },
  get API_GROUP_ASSIGN() {
    return `${this.VERSION}/privilege-groups/assign`;
  },
  get API_GROUP_DELETE() {
    return `${this.VERSION}/privilege-groups/delete`;
  },
  get API_LIST() {
    return `${this.VERSION}/privileges/privilege-all`;
  }
};
export const API_RECEIPT_CATEGORY_ROUTER = {
  VERSION: "v1",
  get API_RECEIPT_CATEGORY_LIST() {
    return `${this.VERSION}/receipt-categories/`;
  },
  get API_RECEIPT_CATEGORY_CREATE() {
    return `${this.VERSION}/receipt-categories/create`;
  },
  API_RECEIPT_CATEGORY_UPDATE(id: number) {
    return `${this.VERSION}/receipt-categories/${id}/update`;
  },
  API_RECEIPT_CATEGORY_DETAIL(id: number) {
    return `${this.VERSION}/receipt-categories/${id}/detail`;
  },
  API_RECEIPT_CATEGORY_CHANGE_STATUS(id: number) {
    return `${this.VERSION}/receipt-categories/${id}/change-status`;
  },
  get API_RECEIPT_CATEGORY_COUNT_TAB() {
    return `${this.VERSION}/accounting-categories/count-tab`;
  },
};
export const API_ACCOUNTING_ACCOUNTS_ROUTER = {
  VERSION: "v1",
  get API_ACCOUNTING_ACCOUNTS_LIST() {
    return `${this.VERSION}/accounting-accounts/`;
  },
  get API_ACCOUNTING_ACCOUNTS_COUNT_TAB() {
    return `${this.VERSION}/accounting-accounts/count-tab`;
  },
  get API_ACCOUNTING_ACCOUNTS_CREATE() {
    return `${this.VERSION}/accounting-accounts/create`;
  },
  API_ACCOUNTING_ACCOUNTS_UPDATE(id: number) {
    return `${this.VERSION}/accounting-accounts/${id}/update`;
  },
  API_ACCOUNTING_ACCOUNTS_DETAIL(id: number) {
    return `${this.VERSION}/accounting-accounts/${id}/detail`;
  },

};

export const API_NOTIFICATION_ROUTER = {
  VERSION: "v1",
  get API_GET_NOTIFICATION() {
    return `${this.VERSION}/notifications`;
  },
  get API_COUNT_READ() {
    return `${this.VERSION}/notifications/read-status`;
  },
  API_MARK_AS_READ(id: string) {
    return `${this.VERSION}/notifications/${id}/mark-as-read`;
  },

  get API_MARK_AS_READ_ALL() {
    return `${this.VERSION}/notifications/mark-as-read-all`;
  },
};

export const API_SETTINGS_ROUTER = {
  VERSION: "v1",

  get API_REGISTER_DEVICE() {
    return `${this.VERSION}/devices/register-device`;

  },
  API_SETTING_DELIVERY_TIME() {
    return `${this.VERSION}/settings/notification/delivery-reminders/schedule`;
  },
  API_SETTING_PICKUP_ACCEPT_TIMEOUT() {
    return `${this.VERSION}/settings/notification/pickup-accept-timeout/schedule`;
  },
  API_SETTING_REMINDER_INTERVAL() {
    return `${this.VERSION}/settings/notification/reminder-interval/schedule`;
  },
  API_DETAIL() {
    return `${this.VERSION}/settings/notification/detail`;
  },
};


export const API_SHIFT_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/shifts/`;
  },
  get API_CREATE() {
    return `${this.VERSION}/shifts/create`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/shifts/${id}/update`;
  },
  API_DETAIL(id: number) {
    return `${this.VERSION}/shifts/${id}/detail`;
  },
  API_CHANGE_STATUS(id: number) {
    return `${this.VERSION}/shifts/${id}/change-status`;
  }
};
export const API_SHIFT_ASSIGNMENT_ROUTER = {
  VERSION: "v1",
  get API_ASSIGMENT_CALENDAR() {
    return `${this.VERSION}/shifts/assignments/calendar`;
  },
  API_ASSIGMENT_CREATE(id: string) {
    return `${this.VERSION}/shifts/${id}/assignments`;
  },
  API_ASSIGMENT_DELETE(id: string) {
    return `${this.VERSION}/shifts/assignments/${id}/delete`;
  },
  API_ASSIGMENT_REMOVE() {
    return `${this.VERSION}/shifts/remove-shift-assignments`;
  }
};
export const API_PAYMENT_PARTNER_ROUTER = {
  VERSION: "v1",
  get API_PAYMENT_DETAIL() {
    return `${this.VERSION}/payment-partners/settings`;
  },
  API_PAYMENT_SETTING() {
    return `${this.VERSION}/payment-partners/settings`;
  },
  API_CANCEL_SETTING() {
    return `${this.VERSION}/payment-partners/cancel`;
  }
};
export const API_ATTENDANCE_ROUTER = {
    VERSION: "v1",
    get API_GET_ATTENDANCE() {
        return `${this.VERSION}/attendance-records`
    },
    get API_GET_ATTENDANCE_DAILY() {
        return `${this.VERSION}/attendance-records/daily`
    },
    get API_GET_ATTENDANCE_GRID() {
        return `${this.VERSION}/attendance-records/grid`
    },
    get API_GET_ATTENDANCE_APPROVE_ISSUE() {
        return `${this.VERSION}/attendance-records/approve-issue`
    },
    get API_ATTENDANCE_CHECK_IN_STATUS() {
        return `${this.VERSION}/attendance-records/check-in-status`
    },
    get API_ATTENDANCE_CHECK_LOCATION_SCOPE() {
        return `${this.VERSION}/attendance-records/check-location-scope`
    },
    get API_ATTENDANCE_CHECK_IN() {
        return `${this.VERSION}/attendance-records/check-in`
    },
    get API_ATTENDANCE_CHECK_OUT() {
        return `${this.VERSION}/attendance-records/check-out`
    },
    get API_ATTENDANCE_EMPLOYEE_DAILY_SESSIONS() {
        return `${this.VERSION}/attendance-records/employee-daily-sessions`
    },
     get API_GET_ATTENDANCE_EXCEL() {
        return `${this.VERSION}/attendance-records/excel-data`
    },
    get API_GET_ATTENDANCE_GRID_EXPORT() {
        return `${this.VERSION}/attendance-records/grid/export-data`
    },
}

// Cài đặt chung của hrm — bao gồm tọa độ/bán kính trụ sở chính dùng để geofence chấm công khi NV
// chưa cấu hình chi nhánh riêng (xem BranchLocationService bên hrm).
export const API_HRM_SETTINGS_ROUTER = {
    VERSION: "v1",
    get API_COMPANY_SETTING() {
        return `${this.VERSION}/settings/company-setting`
    },
}

// Lịch làm việc cố định (NV mode FIXED/NO_ATTENDANCE — không xếp ca) + gán theo bộ phận/cá nhân/mặc
// định toàn hệ thống. Xem hrm/docs/cham-cong-loai-nhan-vien-va-lich-lam-viec-ky-thuat.md bước 3.
export const API_WORK_SCHEDULE_TEMPLATE_ROUTER = {
    VERSION: "v1",
    get API_LIST() {
        return `${this.VERSION}/work-schedule-templates`;
    },
    get API_CREATE() {
        return `${this.VERSION}/work-schedule-templates/create`;
    },
    API_UPDATE(id: number) {
        return `${this.VERSION}/work-schedule-templates/${id}/update`;
    },
    API_DETAIL(id: number) {
        return `${this.VERSION}/work-schedule-templates/${id}/detail`;
    },
};

export const API_ATTENDANCE_SCHEDULE_ASSIGNMENT_ROUTER = {
    VERSION: "v1",
    get API_LIST() {
        return `${this.VERSION}/attendance-schedule-assignments`;
    },
    get API_UPSERT() {
        return `${this.VERSION}/attendance-schedule-assignments`;
    },
};

// Customer Pricing - Giá riêng khách hàng
export const API_CUSTOMER_PRICING_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/customer-pricing`;
  },
  // Danh sách KHÁCH HÀNG có giá riêng, phân trang (mỗi dòng 1 khách + số dịch vụ có giá riêng)
  get API_CUSTOMERS() {
    return `${this.VERSION}/customer-pricing/customers`;
  },
  get API_PREVIEW() {
    return `${this.VERSION}/customer-pricing/preview`;
  },
  get API_BULK_SAVE() {
    return `${this.VERSION}/customer-pricing/bulk-save`;
  },
  get API_SINGLE_SAVE() {
    return `${this.VERSION}/customer-pricing/single-save`;
  },
  get API_APPLICABLE() {
    return `${this.VERSION}/customer-pricing/applicable`;
  },
  API_DELETE(id: number) {
    return `${this.VERSION}/customer-pricing/delete/${id}`;
  },
  API_BY_CUSTOMER(customerId: number) {
    return `${this.VERSION}/customer-pricing/customer/${customerId}`;
  },
  API_BY_CUSTOMER_BRANCH(customerId: number, branchId: number) {
    return `${this.VERSION}/customer-pricing/customer/${customerId}/branch/${branchId}`;
  },
  get API_DELETE_BY_CUSTOMER_BRANCH() {
    return `${this.VERSION}/customer-pricing/delete-by-customer-branch`;
  },

};

// Employee Wage Rates - Đơn giá nhân viên
export const API_WAGE_RATES_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/employee-wage-rates`;
  },
  get API_CREATE() {
    return `${this.VERSION}/employee-wage-rates/create`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/employee-wage-rates/${id}/update`;
  },
  API_DELETE(id: number) {
    return `${this.VERSION}/employee-wage-rates/${id}/delete`;
  },
  get API_ACTIVE() {
    return `${this.VERSION}/employee-wage-rates/active`;
  },
  get API_APPLICABLE() {
    return `${this.VERSION}/employee-wage-rates/applicable`;
  },
};

// Order Employees - Phân công nhân viên
export const API_ORDER_EMPLOYEES_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/order-employees`;
  },
  get API_ASSIGN() {
    return `${this.VERSION}/order-employees/assign`;
  },
  API_UPDATE_STATUS(id: number) {
    return `${this.VERSION}/order-employees/${id}/status`;
  },
  API_UPDATE_WEIGHT(id: number) {
    return `${this.VERSION}/order-employees/${id}/weight`;
  },
  API_BY_ORDER(orderId: number) {
    return `${this.VERSION}/order-employees/order/${orderId}`;
  },
  API_BY_EMPLOYEE(employeeId: number) {
    return `${this.VERSION}/order-employees/employee/${employeeId}`;
  },
  API_DISTRIBUTE_WEIGHT(orderId: number) {
    return `${this.VERSION}/order-employees/order/${orderId}/distribute-weight`;
  },
  get API_KG_REPORT() {
    return `${this.VERSION}/order-employees/kg-report`;
  },
  get API_KG_REPORT_DETAIL() {
    return `${this.VERSION}/order-employees/kg-report/detail`;
  },
  get API_KG_REPORT_EXPORT() {
    return `${this.VERSION}/order-employees/kg-report/export`;
  },
  get API_KG_REPORT_DETAIL_EXPORT() {
    return `${this.VERSION}/order-employees/kg-report/detail/export`;
  },
};

// Order Sessions - Chia đơn
export const API_ORDER_SESSIONS_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/order-sessions`;
  },
  get API_CREATE() {
    return `${this.VERSION}/order-sessions/create`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/order-sessions/${id}`;
  },
  API_DELETE(id: number) {
    return `${this.VERSION}/order-sessions/${id}`;
  },
  API_SUMMARY(orderId: number) {
    return `${this.VERSION}/order-sessions/${orderId}/summary`;
  },
};

// Report - Báo cáo & phân tích
export const API_REPORT_ROUTER = {
  VERSION: "v1",
  get API_SUMMARY() {
    return `${this.VERSION}/order-laundry/report/summary`;
  },
  get API_REVENUE_BY_DATE() {
    return `${this.VERSION}/order-laundry/report/revenue-by-date`;
  },
  get API_REVENUE_BY_BRANCH() {
    return `${this.VERSION}/order-laundry/report/revenue-by-branch`;
  },
  get API_REVENUE_BY_EMPLOYEE() {
    return `${this.VERSION}/order-laundry/report/revenue-by-employee`;
  },
  get API_REVENUE_BY_HOUR() {
    return `${this.VERSION}/order-laundry/report/revenue-by-hour`;
  },
  get API_REVENUE_BY_SERVICE() {
    return `${this.VERSION}/order-laundry/report/revenue-by-service`;
  },
  get API_ORDERS_BY_STATUS() {
    return `${this.VERSION}/order-laundry/report/orders-by-status`;
  },
  get API_DELIVERY_PERFORMANCE() {
    return `${this.VERSION}/order-laundry/report/delivery-performance`;
  },
};

// Equipment - Quản lý thiết bị
export const API_EQUIPMENT_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/equipments/`;
  },
  get API_CREATE() {
    return `${this.VERSION}/equipments/create`;
  },
  get API_BULK_CREATE() {
    return `${this.VERSION}/equipments/bulk-create`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/equipments/${id}/update`;
  },
  API_DELETE(id: number) {
    return `${this.VERSION}/equipments/${id}/delete`;
  },
  API_ASSIGN(id: number) {
    return `${this.VERSION}/equipments/${id}/assign`;
  },
  API_RELEASE(id: number) {
    return `${this.VERSION}/equipments/${id}/release`;
  },
  get API_AVAILABLE() {
    return `${this.VERSION}/equipments/available`;
  },
  get API_SCAN() {
    return `${this.VERSION}/equipments/scan`;
  },
  API_ORDER_SUMMARY(orderId: number) {
    return `${this.VERSION}/equipments/order/${orderId}/summary`;
  },
};

// Workflow Steps - Cấu hình bước workflow (Phase 2)
export const API_WORKFLOW_ROUTER = {
  VERSION: "v1",
  get API_STEPS() {
    return `${this.VERSION}/workflow/steps`;
  },
  get API_SEED_DEFAULT() {
    return `${this.VERSION}/workflow/steps/seed-default`;
  },
  API_UPDATE_STEP(id: number) {
    return `${this.VERSION}/workflow/steps/${id}/update`;
  },
  get API_REORDER() {
    return `${this.VERSION}/workflow/steps/reorder`;
  },
};

// Branch Settings - Cài đặt chi nhánh
export const API_BRANCH_SETTINGS_ROUTER = {
  VERSION: "v1",
  API_GET(branchId: number) {
    return `${this.VERSION}/branch-settings/${branchId}`;
  },
  API_UPDATE(branchId: number) {
    return `${this.VERSION}/branch-settings/${branchId}`;
  },
  API_SKIP_PRODUCTION_CUSTOMERS(branchId: number) {
    return `${this.VERSION}/branch-settings/${branchId}/skip-production-customers`;
  },
  API_SKIP_PRODUCTION_CUSTOMERS_REMOVE(branchId: number) {
    return `${this.VERSION}/branch-settings/${branchId}/skip-production-customers/remove`;
  },
};

// Clothing Categories - Quản lý loại đồ giặt
export const API_CLOTHING_CATEGORY_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/clothing-categories/`;
  },
  get API_CREATE() {
    return `${this.VERSION}/clothing-categories/create`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/clothing-categories/${id}/update`;
  },
};

// Recurring Orders - Đơn hàng định kỳ
export const API_RECURRING_ORDER_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/recurring-orders`;
  },
  get API_CREATE() {
    return `${this.VERSION}/recurring-orders/create`;
  },
  API_DETAIL(id: number) {
    return `${this.VERSION}/recurring-orders/${id}`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/recurring-orders/${id}/update`;
  },
  API_TOGGLE(id: number) {
    return `${this.VERSION}/recurring-orders/${id}/toggle-status`;
  },
  API_END(id: number) {
    return `${this.VERSION}/recurring-orders/${id}/end`;
  },
  API_FROM_ORDER(orderId: number) {
    return `${this.VERSION}/recurring-orders/create-from-order/${orderId}`;
  },
  API_ASSIGN_STAFF(id: number) {
    return `${this.VERSION}/recurring-orders/${id}/assign-staff`;
  },
};

// Driver Cash Ledger - Sổ quỹ tiền mặt tài xế
export const API_DRIVER_CASH_LEDGER_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/driver-cash-ledger/transactions`;
  },
  get API_ALL_BALANCES() {
    return `${this.VERSION}/driver-cash-ledger/drivers`;
  },
  API_DRIVER_LEDGER(driverId: number) {
    return `${this.VERSION}/driver-cash-ledger/driver/${driverId}`;
  },
  API_DRIVER_BALANCE(driverId: number) {
    return `${this.VERSION}/driver-cash-ledger/driver/${driverId}/balance`;
  },
  get API_WITHDRAWALS() {
    return `${this.VERSION}/driver-cash-ledger/withdrawals`;
  },
  get API_CREATE_WITHDRAWAL() {
    return `${this.VERSION}/driver-cash-ledger/withdrawals/create`;
  },
  API_APPROVE_WITHDRAWAL(id: number) {
    return `${this.VERSION}/driver-cash-ledger/withdrawals/${id}/approve`;
  },
  API_REJECT_WITHDRAWAL(id: number) {
    return `${this.VERSION}/driver-cash-ledger/withdrawals/${id}/reject`;
  },
  get API_DEBT_REMINDER_SETTINGS() {
    return `${this.VERSION}/driver-cash-ledger/debt-reminder-settings`;
  },
  /** Sổ quỹ theo chi nhánh / nhân viên (tồn đầu · thu · nộp · tồn cuối) */
  get API_REPORT() {
    return `${this.VERSION}/driver-cash-ledger/report`;
  },
  /** Xuất Excel sổ quỹ theo chi nhánh / nhân viên — trả file ngay */
  get API_REPORT_EXPORT() {
    return `${this.VERSION}/driver-cash-ledger/report/export`;
  },
};

// Customer Debt - Công nợ khách hàng
export const API_CUSTOMER_DEBT_ROUTER = {
  VERSION: "v1",
  get API_SUMMARY() {
    return `${this.VERSION}/customer-debt/summary`;
  },
  get API_CUSTOMER_ORDERS() {
    return `${this.VERSION}/customer-debt/customer-orders`;
  },
  API_PAY(id: number) {
    return `v1/customer-debt/${id}/pay`;
  },
};
// Material Types - Loại vật tư (PRODUCT_SERVICE)
// Danh mục phẳng, là cha của vật tư. Xem product/docs/vat-tu-va-tinh-tien-ky-thuat.md
export const API_MATERIAL_TYPE_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/material-types/list`;
  },
  get API_CREATE() {
    return `${this.VERSION}/material-types/create`;
  },
  API_DETAIL(id: number) {
    return `${this.VERSION}/material-types/${id}`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/material-types/${id}/update`;
  },
  API_CHANGE_STATUS(id: number) {
    return `${this.VERSION}/material-types/${id}/change-status`;
  },
};

// Units - Đơn vị bán và đơn vị đo lường (PRODUCT_SERVICE)
export const API_UNIT_ROUTER = {
  VERSION: "v1",
  get API_LIST() {
    return `${this.VERSION}/units/list`;
  },
  get API_CREATE() {
    return `${this.VERSION}/units/create`;
  },
  API_UPDATE(id: number) {
    return `${this.VERSION}/units/${id}/update`;
  },
  API_CHANGE_STATUS(id: number) {
    return `${this.VERSION}/units/${id}/change-status`;
  },
};
